import { useSearchParams } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { useSeo } from "@/hooks/useSeo";
import HomeHero from "@/pages/home/components/HomeHero";
import FocusSection from "@/pages/home/components/FocusSection";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import LatestSection from "@/pages/home/components/LatestSection";
import HotSection from "@/pages/home/components/HotSection";
import SiteIntro from "@/pages/home/components/SiteIntro";
import SearchResults from "@/pages/home/components/SearchResults";

export default function Home() {
  const [searchParams] = useSearchParams();
  const keyword = (searchParams.get("q") || "").trim();

  useSeo({
    title: keyword
      ? `搜索：${keyword} - 黑料官网`
      : "黑料官网-权威黑料信息汇总与最新动态",
    description:
      "黑料官网为您提供丰富的黑料信息汇总、最新动态及深度解析，覆盖各类热门话题和事件，方便用户及时了解真实内幕和社会热点。",
    keywords:
      "黑料官网,黑料信息,内幕揭秘,热门黑料,社会热点,最新黑料,真实内幕",
  });

  return (
    <SiteLayout>
      {keyword ? (
        <SearchResults keyword={keyword} />
      ) : (
        <>
          <HomeHero />
          <FocusSection />
          <CategoryGrid />
          <section className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
            <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
              <div className="lg:col-span-2">
                <LatestSection />
              </div>
              <div className="lg:col-span-1">
                <div className="lg:sticky lg:top-20">
                  <HotSection />
                </div>
              </div>
            </div>
          </section>
          <SiteIntro />
        </>
      )}
    </SiteLayout>
  );
}